import { render, staticRenderFns } from "./ForgetPasswordComp.vue?vue&type=template&id=56fc760e&scoped=true&"
import script from "./ForgetPasswordComp.vue?vue&type=script&lang=ts&"
export * from "./ForgetPasswordComp.vue?vue&type=script&lang=ts&"
import style0 from "./ForgetPasswordComp.vue?vue&type=style&index=0&id=56fc760e&lang=scss&scoped=true&"
import style1 from "./ForgetPasswordComp.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fc760e",
  null
  
)

export default component.exports